
/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'flag-lu': {
    width: 640,
    height: 480,
    viewBox: '0 0 640 480',
    data: '<path pid="0" _fill="#00a1de" d="M0 240h640v240H0z"/><path pid="1" _fill="#ed2939" d="M0 0h640v240H0z"/><path pid="2" _fill="#fff" d="M0 160h640v160H0z"/>'
  }
})
